<template>
    <component
        v-if="processedRetailers"
        :is="tag"
        class="product-retail-links"
    >
        <slot name="header" />
        <v-list
            class="pa-0"
            border
            rounded="lg"
        >
            <ProductRetailLinksItem
                v-for="(item, index) in processedRetailers"
                :key="`prod-retail-link-item-${index}`"
                :item="item"
            ></ProductRetailLinksItem>
            <v-divider></v-divider>
            <v-list-item
                class="retailer-item"
                to="/retailers/stores/"
                color="secondary"
                :model-value="true"
                :title.prop="`Find a Store`"
            >
                <div
                    class="font-weight-bold font-size-6"
                >
                    Find A Store
                </div>
                <template #append>
                    <v-icon
                        color="secondary"
                        :icon="mdiMapSearch"
                        size="18"
                    ></v-icon>
                </template>
            </v-list-item>
        </v-list>
    </component>
</template>

<script lang="ts" setup>
    import ProductRetailLinksItem from '~/components/products/ProductRetailLinksItem/ProductRetailLinksItem.vue';

    import type {
        ProductRetailer,
        ProductRetailerUrl,
        ProcessedProductRetailer,
        Sku
    } from '~/types';
    import { mdiMapSearch } from '@mdi/js';

    const props = withDefaults(
        defineProps<{
            retailers: ProductRetailer[];
            currentSku: Sku;
            tag?: string;
        }>(),
        {
            tag: 'div'
        }
    );

    const processedRetailers = ref<Nilish<ProcessedProductRetailer[]>>();

    const unWatchCurrentOptions = watch(
        () => props.currentSku,
        (newSku) => {
            processList(newSku.optionUids);
        },
        {
            immediate: true
        }
    );

    function processList(optionUids: Nilish<string[]>): void {
        if (!optionUids?.length) {
            return;
        }

        const items = props.retailers?.reduce((acc: ProcessedProductRetailer[], retailer) => {
            const values = retailer.urls.reduce((acc2: ProductRetailerUrl[], urlObj) => {
                const uids = urlObj.options.map((opt) => opt.uid);
                const hasRefs = uids.some((o) => optionUids.includes(o));

                if (!uids?.length || hasRefs) {
                    acc2.push(urlObj);
                }

                return acc2;
            }, []);

            if (values.length) {
                acc.push([retailer.org, values]);
            }

            return acc;
        }, []);

        processedRetailers.value = items?.length ? items : null;
    }

    onBeforeUnmount(() => {
        unWatchCurrentOptions();
    });
</script>

<style lang="scss" scoped></style>
